angular.module('unica_transfer.transfer_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// TRANSFER LIST AND DELETE
		.state('app.hospitality.transfer_list', {
			url: '/transfer-list',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/transfer/templates/list.html',
					controller: 'TransferListController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Transfers',
				parent: 'app.hospitality.dashboard'
			}
		})

		// TRANSFER CREATE
		.state('app.hospitality.transfer_create', {
			url: '/transfer-create',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/transfer/templates/create.html',
					controller: 'TransferCreateController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Aggiungi Transfer',
				parent: 'app.hospitality.transfer_list'
			}
		})

		// TRANSFER EDIT
		.state('app.hospitality.transfer_edit', {
			url: '/transfer-edit/:id',
			views: {
				'hospitalityContent': {
					templateUrl: './modules/transfer/templates/edit.html',
					controller: 'TransferEditController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Modifica Transfer',
				parent: 'app.hospitality.transfer_list'
			}
		});




});

